// extracted by mini-css-extract-plugin
export default {"content":"App_content__wwONY","stuff":"App_stuff__mVhWY","guy":"App_guy__ojAml"};